__turbopack_context__.v({
  "blocksBackgroundColor": "Terrace-module-scss-module__bngnuG__blocksBackgroundColor",
  "blocksFontColor": "Terrace-module-scss-module__bngnuG__blocksFontColor",
  "editButton": "Terrace-module-scss-module__bngnuG__editButton",
  "secondaryNavBackgroundColor": "Terrace-module-scss-module__bngnuG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "Terrace-module-scss-module__bngnuG__themeBackgroundColor",
  "themeFontColor": "Terrace-module-scss-module__bngnuG__themeFontColor",
});
